
import React, { useState } from 'react';
import { GuestPanel } from './components/GuestPanel';
import { AdminPanel } from './components/AdminPanel';

export default function App() {
  const [viewMode, setViewMode] = useState<'guest' | 'admin'>('guest');
  const [isAutoAuthenticated, setIsAutoAuthenticated] = useState(false);

  const handleSwitchToAdmin = (autoAuth: boolean = false) => {
      setIsAutoAuthenticated(autoAuth);
      setViewMode('admin');
  };

  const handleLogout = () => {
      setIsAutoAuthenticated(false);
      setViewMode('guest');
  };

  return (
    <>
      {viewMode === 'guest' ? (
        <GuestPanel onSwitchToAdmin={handleSwitchToAdmin} />
      ) : (
        <AdminPanel onLogout={handleLogout} autoAuth={isAutoAuthenticated} />
      )}
    </>
  );
}
